import { getClosestPastDate } from "@/helpers/format-date";
import { DEFAULT_STATE } from "./store";
import {
	DailyForecast,
	DailyMarineState,
	ForecastKuwaitState,
	LocationMarine,
	MarineForcast,
	PrayerState,
	PrevisionMarine,
	StationMarine,
	TideState,
	WarningState,
	WarningTimelineState,
} from "./type";
import { IWorldCitiesFeatures } from "@/schemas/world-city-schema";
import { WorldForecastSchema } from "@/schemas/world-forecast-schema";
import { forecastType } from "@/schemas/prevision-data-schema";
import { CityFeature } from "@/schemas/city-schema";
import { observationsType } from "@/schemas/observation-schema";
import { imageFilesType } from "@/schemas/imagery-schema";
import { IImageryFilter } from "@/types/imagery-type";

export const selectors = {
	/* SELECTOR FOR FORECASTCITY */
	getCityPrevisionState(state = DEFAULT_STATE): {
		forecastData: forecastType | null;
		isLoading: boolean;
		error: string | null;
	} {
		return state.forecastCity.forecast;
	},

	getCityLocationState(state = DEFAULT_STATE): {
		cityNameEn: string;
		cityNameAr: string;
		cityId: string;
	} {
		return state.forecastCity.location;
	},

	getCurrentUserLocation(state = DEFAULT_STATE): {
		cityNameEn: string;
		cityNameAr: string;
		cityId: string;
	} | null {
		return state.forecastCity.userLocation;
	},

	getDateSelectedCityState(state = DEFAULT_STATE): Date {
		return state.forecastCity.selectedDate;
	},

	getCityState(state = DEFAULT_STATE): {
		isLoading: boolean;
		cityData: CityFeature[];
		error: null | string;
	} {
		return state.forecastCity.cities;
	},

	/* SELECTOR FOR DAILY FORECAST */
	getDailyForecast(state = DEFAULT_STATE): DailyForecast {
		return state.dailyForecast;
	},

	/* SELECTOR FOR MARINE FORECAST */
	getMarineDate(state = DEFAULT_STATE): PrevisionMarine {
		return state.previsionMarine;
	},

	getLocationMarine(state = DEFAULT_STATE): LocationMarine {
		return state.marineLocation;
	},

	/* SELECTOR FOR MARINE */
	getPrayerState(state = DEFAULT_STATE): PrayerState {
		return state.prayer;
	},

	/* SELECTOR FOR WARNING */
	getWarningState(state = DEFAULT_STATE): WarningState {
		return state.warning;
	},

	/* SELECTOR FOR TIDES */
	getTideState(state = DEFAULT_STATE): TideState {
		return state.tide;
	},

	/* SELECTOR FOR OBSERVATION */
	getObservationStationState(state = DEFAULT_STATE): {
		stationData: observationsType[];
		isLoading: boolean;
		error: string | null;
	} {
		return state.observation.stations;
	},

	getObservationDateSelectedState(state = DEFAULT_STATE): Date {
		return getClosestPastDate(state.observation.selectedDate);
	},

	getObservationImageryState(state = DEFAULT_STATE): {
		imageryData: imageFilesType[];
		isLoading: boolean;
		error: string | null;
	} {
		return state.observation.imageryTiff;
	},

	getObservationFilterState(state = DEFAULT_STATE): IImageryFilter {
		return state.observation.imageryFilter;
	},

	/* SELECTOR FOR KUWAIT  */
	getForecastKuwaitState(state = DEFAULT_STATE): ForecastKuwaitState {
		return state.forecastKuwait;
	},

	/* SELECTOR FOR WORLD STATE  */

	getWorldCitiesState(state = DEFAULT_STATE): {
		cityData: IWorldCitiesFeatures;
		isLoading: boolean;
		error: string | null;
	} {
		return state.worldForecast.cities;
	},

	getWorldForecastPrevisionState(state = DEFAULT_STATE): {
		isLoading: boolean;
		error: string | null;
		forecastData: WorldForecastSchema;
	} {
		return state.worldForecast.forecast;
	},

	getWorldLocationState(state = DEFAULT_STATE): {
		id: string;
		name: string;
	} {
		return state.worldForecast.selectedLocation;
	},

	getWorldForecastPrevisionDateState(state = DEFAULT_STATE): Date {
		return state.worldForecast.selectedDate;
	},

	getTimelineState(state = DEFAULT_STATE): WarningTimelineState {
		return state.timeline;
	},

	getMarineStationState(state = DEFAULT_STATE): StationMarine {
		return state.marineStation;
	},

	getDailyMarineState(state = DEFAULT_STATE): DailyMarineState {
		return state.dailyMarine;
	},

	getMarineForecastState(state = DEFAULT_STATE): MarineForcast {
		return state.marineForecast;
	},
};
